import React, { useState, useEffect } from "react";
import classNames from "classnames/bind";
import { Pagination, Table as TB } from "../../../components";
import axiosClient from "../../../services/axiosClient";
// import { role } from "../../../services/api/RoleApi";
import { formatDate, formatDateToTime, formatDB, sorterArray } from "../../../utils";
import Filter from "../Access/Filter/Filter";
import styles from './Configuration.module.css';
import NameCol from "../../../components/NameCol";
import Nodata from "../NoData/Nodata";

const cx = classNames.bind(styles);
const Configuration = () => {
  const [config, setConfig] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [textSearch, setTextSearch] = useState();
  const [toggleSort, setToggleSort] = useState(false)
  const [dataTable, setDataTable] = useState()
  const [method, setMethod] = useState('')
  const handleClick = (page) => {
    setCurrentPage(page);
  };
  const handleNext = () => {
    setCurrentPage(currentPage + 1);
  };
  const handlePrevious = () => {
    setCurrentPage(currentPage - 1);
  };
  const onChangeTextSearch = (data) => {
    setTextSearch(data);
    setCurrentPage(1)
  };
  const onChangeDateStart = (data) => {
    setStartDate(data);
  };
  const onChangeDateEnd = (data) => {
    setEndDate(data);
  };
  useEffect(() => {
    async function getHistoryConfig() {
      const date =
        startDate && endDate
          ? {
            day_start: formatDB(startDate),
            day_end: formatDB(endDate),
          }
          : {};
      const res = await axiosClient.get("/camConfigHistory/get-list-cam-config-history/", {
        params: {
          page: currentPage,
          size: 10,
          ...date,
          username: textSearch,
        },
      });
     
      if (res.count) {
        setPages(Math.ceil(res.count / 10));
      } else {
        setPages(1);
      }
      setConfig(res.data);
    }
    getHistoryConfig();
  }, [currentPage, textSearch, endDate, startDate]);

  useState(() => {
    const dateNow = new Date()
    const time = formatDate(dateNow)
    setStartDate(time);
    setEndDate(time)
  }, [])

  useEffect(() => {
    const newData = config.length > 0 ? [...config] : null
    if (newData && method.length > 0) {
      switch (toggleSort) {
        case 'up':
          const dataSortUp = sorterArray(newData, method)
          setDataTable(dataSortUp)
          break;
        case 'down':
          const dataSortDown = sorterArray(newData, method)
          setDataTable(dataSortDown.reverse())
          break;
        default:
          setDataTable(newData)
          break;
      }
    } else {
      setDataTable(newData)
    }
  }, [config, toggleSort, method])

  const handleSort = (type, method) => {
    if (type !== toggleSort) {
      setToggleSort(type)
      setMethod(method)
    } else {
      setToggleSort(false)
      setMethod('')
    }
  }


  const dataSource = dataTable?.map((item, index) => {
    return {
      stt: index + 1,
      date: formatDateToTime(item.TIME),
      username: item.USERNAME,
      action: item.ACTION_NAME,
      type: item.TYPE_CONFIG,
      object: item.OBJECT_CODE,
    };
  });


  const columns = [
    {
      label: "STT",
      key: "stt",
    },
    {
      label: <NameCol active={method} title={'Tài khoản'} handleSort={handleSort} method={'USERNAME'} />,
      key: "username",
    },
    {
      label: <NameCol active={method} title={'Loại cấu hình'} handleSort={handleSort} method={'TYPE_CONFIG'} />,
      key: "type",
    },
    {
      label: <NameCol active={method} title={'Hành động'} handleSort={handleSort} method={'ACTION_NAME'} />,
      key: "action",
    },
    {
      label: <NameCol active={method} title={'Đối tượng'} handleSort={handleSort} method={'OBJECT_CODE'} />,
      key: "object"
    },
    {
      label: <NameCol active={method} title={'Thời gian'} handleSort={handleSort} method={'TIME'} />,
      key: 'date'
    },
  ];
  return (
    <>
      <div className={cx("header")}>
        <h1 className={cx("title")}>Lịch sử cấu hình</h1>
      </div>
      <div className={cx('content')}>
        <Filter
          changeTextSearch={onChangeTextSearch}
          dayStart={startDate}
          dayEnd={endDate}
          onChangeDayStart={onChangeDateStart}
          onChangeDayEnd={onChangeDateEnd}
        />
        <TB data={dataSource} colum={columns} />
        {dataSource?.length > 0 ?  <div className={cx("pagination")}>
          <Pagination
            onClick={handleClick}
            onNext={handleNext}
            onPrevious={handlePrevious}
            pages={pages}
            currentPage={currentPage}
          />
        </div>:<Nodata/>}
      </div>
    </>
  );
};

export default Configuration;
